<script>
import { mapGetters } from 'vuex'
import TheNav from '@/components/PromoSite/TheNav'
import TheFooter from '@/components/TheFooter'
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'App',
  components: {
    TheNav,
    TheFooter,
    CookieLaw
  },
  computed: {
    ...mapGetters({
      pricingTag: 'brochure/pricingTag',
      isHomeProgram: 'brochure/isHomeProgram',
      isTodos: 'brochure/isTodos',
      isBrainRehabPromo: 'brochure/isBrainRehab'
    }),
    showBernellLink () {
      const partnerCode = (typeof this.pricingTag === 'string') ? this.pricingTag.toLowerCase() : null
      return ((this.$route.name !== 'PartnerView') && (partnerCode === 'bernell'))
    },
    showFreeTrial () {
      return ((this.$route.name !== 'BrochureFreeTrial') && (this.isBrainRehabPromo === false) && (this.isHomeProgram === false) && (this.isTodos === false) && (this.$route.name !== 'MaintenancePatientsView'))
    },
    isPromoHome () {
      return (this.$route.name === 'HomeView')
    }
  },
  methods: {
    onFreeTrial () {
      this.$router.push('/free-trial')
    },
    onBernellLink () {
      this.$router.push('/partners/bernell')
    }
  }
}
</script>

<template>
  <div id="app">
    <the-nav
        :class="{'is-promo-home': isPromoHome }"
    />
    <div
      v-if="showFreeTrial"
      @click="onFreeTrial"
      class="free-demo-bar"
    >
      <div class="free-demo-text text-outline-dark">
        Start Your Free Trial!
      </div>
    </div>
    <div
      v-if="showBernellLink"
      class="bernell-link"
      @click="onBernellLink"
    >
      <span class="bernell-link-text text-outline-dark">Bernell Plans</span>
      <span class="icon is-small bernell-link-text">
        <i class="mdi mdi-arrow-right"></i>
      </span>
    </div>
    <div class="site-layout">
      <div class="view-screen">
        <div class="content-wrapper">
          <main class="content-area">
            <transition name="fade" mode="out-in">
              <div :key="$route.fullPath" class="page-content">
                <router-view />
              </div>
            </transition>
          </main>
        </div>
        <svg width="1" height="1" viewBox="100 0 900 200">
          <filter id="outline-light">
            <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius="1"></feMorphology>

            <feFlood flood-color="#ffffff" flood-opacity="0.10" result="PINK"></feFlood>
            <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE"></feComposite>

            <feMerge>
              <feMergeNode in="OUTLINE" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <svg width="1" height="1" viewBox="100 0 900 200">
            <filter id="outline-dark">
              <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius="1"></feMorphology>

              <feFlood flood-color="#000000" flood-opacity="0.10" result="PINK"></feFlood>
              <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE"></feComposite>

              <feMerge>
                <feMergeNode in="OUTLINE" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </svg>
        </svg>
        <the-footer />
      </div>
    </div>
    <cookie-law theme="ovb" />
  </div>
</template>

<style lang="scss">
  @import "assets/scss/_common";
  body {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  #app {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 100vh;
    .bernell-link {
      position: fixed;
      top: 4rem;
      right: 0;
      z-index: 75;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $primary;
      padding: 0.5rem 1rem;
      cursor: pointer;
      width: 100%;
      &:hover { filter: saturate(1.5); }
      @include tablet {
        top: 8rem;
        width: auto;
        bottom: auto;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
      .bernell-link-text {
        font-size: 1.15rem;
        font-family: $family-semibold;
        color: $white;
      }
    }
    .free-demo-bar {
      position: fixed;
      bottom: 0;
      right: 0;
      z-index: 70;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $watermelon;
      padding: 0.5rem 1rem;
      cursor: pointer;
      border-bottom-left-radius: 0.25rem;
      width: 100%;
      &:hover {
        filter: saturate(1.5);
      }
      @include tablet {
        top: 4rem;
        width: auto;
        bottom: auto;
      }
      @include desktop {
        top: 3.6rem;
        width: auto;
      }
      .free-demo-text {
        font-size: 1.15rem;
        font-family: $family-semibold;
        color: #fff;
      }
    }
    .home-program-bar {
      position: fixed;
      bottom: 0;
      right: 0;
      z-index: 70;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $watermelon;
      padding: 0.5rem 1rem;
      cursor: pointer;
      border-bottom-left-radius: 0.25rem;
      width: 100%;
      &:hover {
        filter: saturate(1.5);
      }
      @include tablet {
        top: 4rem;
        width: auto;
        bottom: auto;
      }
      @include desktop {
        top: 3.6rem;
        width: auto;
      }
      .home-program-text {
        font-size: 1.5rem;
        font-family: $family-semibold;
        color: #fff;
      }
    }
  }
  .view-screen {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .site-layout {
    display: flex;
    flex-grow: 1;
  }
  .content-wrapper {
    flex-grow: 1;
    display: flex;
  }
  main.content-area {
    display: flex;
    flex-grow: 1;
  }
  .page-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .copyright-notice {
    margin-top: 1rem;
    flex: 1;
    font-size: $size-6;
  }
</style>
